function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import Vue from 'vue';
var POSITION = {
  top: 'top',
  bottom: 'bottom'
};
var script = {
  name: 'Tooltip',
  props: {
    offset: {
      type: Number,
      "default": 12
    },
    withArrow: {
      type: Boolean,
      "default": false
    },
    position: {
      type: String,
      "default": POSITION.bottom
    },
    backgroundColor: {
      type: String,
      "default": null
    },
    classes: {
      type: String,
      "default": ''
    },
    styles: {
      type: Object,
      "default": function _default() {
        return {};
      }
    },
    value: {
      type: Boolean,
      "default": undefined
    }
  },
  data: function data() {
    return {
      target: null,
      tooltip: null
    };
  },
  watch: {
    value: function value() {
      this.value === true && this.show();
      this.value === false && this.destroy();
    }
  },
  computed: {
    computedStyles: function computedStyles() {
      var styles = {};

      for (var _i = 0, _Object$entries = Object.entries(_objectSpread({}, this.styles)); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
            key = _Object$entries$_i[0],
            value = _Object$entries$_i[1];

        styles[key] = value;
      }

      return _objectSpread(_objectSpread({}, styles), this.backgroundColor && {
        backgroundColor: this.backgroundColor,
        borderColor: this.backgroundColor
      });
    }
  },
  methods: {
    show: function show() {
      this.create();
      this.setPosition();
      this.tooltip.$el.classList.add('active');
    },
    create: function create() {
      var _this = this;

      if (this.tooltip) {
        return;
      }

      var el = document.createElement('div');
      document.body.append(el);
      var Tooltip = Vue.extend({
        render: function render(h) {
          var _class;

          return h('div', {
            attrs: {
              __tooltip__: ''
            },
            "class": (_class = {
              tooltip: true,
              'tooltip--anchor': _this.withArrow
            }, _defineProperty(_class, "tooltip--position-".concat(_this.position), true), _defineProperty(_class, _this.classes, true), _class),
            style: _this.computedStyles
          }, _this.$slots["default"]);
        }
      });
      this.tooltip = new Tooltip().$mount(el);
    },
    destroy: function destroy() {
      var _this2 = this;

      if (!this.tooltip) {
        return;
      }

      this.tooltip.$el.classList.remove('active');

      if (this.value) {
        this.$emit('input', false);
      }

      setTimeout(function () {
        var _this2$tooltip;

        (_this2$tooltip = _this2.tooltip) === null || _this2$tooltip === void 0 ? void 0 : _this2$tooltip.$el.remove();
        _this2.tooltip = null;
      }, 200);
    },
    setPosition: function setPosition() {
      var targetCoords = this.target.getBoundingClientRect();
      var targetCenterY = targetCoords.x + targetCoords.width / 2;
      var tooltipCoords = this.tooltip.$el.getBoundingClientRect();

      switch (this.position) {
        case POSITION.bottom:
          {
            this.tooltip.$el.style.top = targetCoords.y + targetCoords.height + this.offset + 'px';
            this.tooltip.$el.style.left = targetCenterY - tooltipCoords.width / 2 + 'px';
            break;
          }

        case POSITION.top:
          {
            this.tooltip.$el.style.top = targetCoords.y - tooltipCoords.height - this.offset + 'px';
            this.tooltip.$el.style.left = targetCenterY - tooltipCoords.width / 2 + 'px';
            break;
          }
      }
    }
  },
  mounted: function mounted() {
    this.target = this.$el.parentElement;

    if (this.value === undefined) {
      this.target.addEventListener('mouseover', this.show);
      this.target.addEventListener('mouseleave', this.destroy);
    }

    document.addEventListener('scroll', this.destroy);

    if (this.value === true) {
      this.show();
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.target.removeEventListener('mouseover', this.show);
    this.target.removeEventListener('mouseleave', this.destroy);
    document.removeEventListener('scroll', this.destroy);
  },
  render: function render(h) {
    return h('');
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function (context) {
      style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());

function createInjector(context) {
  return function (id, style) {
    return addStyle(id, style);
  };
}

var HEAD;
var styles = {};

function addStyle(id, css) {
  var group = isOldIE ? css.media || 'default' : id;
  var style = styles[group] || (styles[group] = {
    ids: new Set(),
    styles: []
  });

  if (!style.ids.has(id)) {
    style.ids.add(id);
    var code = css.source;

    if (css.map) {
      // https://developer.chrome.com/devtools/docs/javascript-debugging
      // this makes source maps inside style tags work properly in Chrome
      code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'; // http://stackoverflow.com/a/26603875

      code += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) + ' */';
    }

    if (!style.element) {
      style.element = document.createElement('style');
      style.element.type = 'text/css';
      if (css.media) style.element.setAttribute('media', css.media);

      if (HEAD === undefined) {
        HEAD = document.head || document.getElementsByTagName('head')[0];
      }

      HEAD.appendChild(style.element);
    }

    if ('styleSheet' in style.element) {
      style.styles.push(code);
      style.element.styleSheet.cssText = style.styles.filter(Boolean).join('\n');
    } else {
      var index = style.ids.size - 1;
      var textNode = document.createTextNode(code);
      var nodes = style.element.childNodes;
      if (nodes[index]) style.element.removeChild(nodes[index]);
      if (nodes.length) style.element.insertBefore(textNode, nodes[index]);else style.element.appendChild(textNode);
    }
  }
}
/* script */


var __vue_script__ = script;
/* template */

/* style */

var __vue_inject_styles__ = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-6e2574b3_0", {
    source: "[__tooltip__].tooltip {\n  display: block;\n  border-radius: 4px;\n  box-shadow: 0 2px 24px 0 rgba(0,0,0,0.16);\n  padding: 6px 8px;\n  position: fixed;\n  z-index: 1000000;\n  background-color: #505050;\n  transition: opacity 0.2s, transform 0.2s;\n  opacity: 0;\n  pointer-events: none;\n  border-color: #505050;\n  font-size: 14px;\n  line-height: 18px;\n  color: #fff;\n}\n[__tooltip__].tooltip--anchor::before {\n  content: '';\n  display: block;\n  border-style: solid;\n  border-width: 6px;\n  position: absolute;\n  left: 50%;\n  border-color: transparent;\n  transform: translateX(-50%);\n}\n[__tooltip__].tooltip--position-bottom {\n  transform: translateY(-10px);\n}\n[__tooltip__].tooltip--position-bottom::before {\n  border-top: none;\n  top: -6px;\n  border-bottom-color: inherit;\n}\n[__tooltip__].tooltip--position-top {\n  transform: translateY(10px);\n}\n[__tooltip__].tooltip--position-top::before {\n  border-color: transparent;\n  border-bottom: none;\n  bottom: -6px;\n  border-top-color: inherit;\n}\n[__tooltip__].tooltip.active {\n  opacity: 1;\n  transform: translateY(0);\n}\n",
    map: {
      "version": 3,
      "sources": ["C:\\Users\\Oleksandr\\Projects\\tooltip-vue\\src\\Tooltip.vue", "Tooltip.vue"],
      "names": [],
      "mappings": "AAoLA;EACA,cAAA;EACA,kBAAA;EACA,yCAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,wCAAA;EACA,UAAA;EACA,oBAAA;EACA,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;ACnLA;ADsLA;EACA,WAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;EACA,yBAAA;EACA,2BAAA;ACpLA;ADsLA;EACA,4BAAA;ACpLA;ADqLA;EACA,gBAAA;EACA,SAAA;EACA,4BAAA;ACnLA;ADqLA;EACA,2BAAA;ACnLA;ADoLA;EACA,yBAAA;EACA,mBAAA;EACA,YAAA;EACA,yBAAA;AClLA;ADoLA;EACA,UAAA;EACA,wBAAA;AClLA",
      "file": "Tooltip.vue",
      "sourcesContent": ["<script>\nimport Vue from 'vue'\n\nconst POSITION = {\n  top: 'top',\n  bottom: 'bottom'\n}\n\nexport default {\n  name: 'Tooltip',\n\n  props: {\n    offset: {\n      type: Number,\n      default: 12\n    },\n    withArrow: {\n      type: Boolean,\n      default: false\n    },\n    position: {\n      type: String,\n      default: POSITION.bottom\n    },\n    backgroundColor: {\n      type: String,\n      default: null\n    },\n    classes: {\n      type: String,\n      default: ''\n    },\n    styles: {\n      type: Object,\n      default: () => ({})\n    },\n    value: {\n      type: Boolean,\n      default: undefined\n    }\n  },\n\n  data: () => ({\n    target: null,\n    tooltip: null\n  }),\n\n  watch: {\n    value() {\n      this.value === true && this.show()\n      this.value === false && this.destroy()\n    }\n  },\n\n  computed: {\n    computedStyles() {\n      const styles = {}\n\n      for (const [key, value] of Object.entries({ ...this.styles })) {\n        styles[key] = value\n      }\n\n      return {\n        ...styles,\n        ...(this.backgroundColor && {\n          backgroundColor: this.backgroundColor,\n          borderColor: this.backgroundColor\n        })\n      }\n    }\n  },\n\n  methods: {\n    show() {\n      this.create()\n      this.setPosition()\n      this.tooltip.$el.classList.add('active')\n    },\n\n    create() {\n      if (this.tooltip) {\n        return\n      }\n\n      const el = document.createElement('div')\n      document.body.append(el)\n\n      const Tooltip = Vue.extend({\n        render: (h) =>\n          h(\n            'div',\n            {\n              attrs: {\n                __tooltip__: ''\n              },\n              class: {\n                tooltip: true,\n                'tooltip--anchor': this.withArrow,\n                [`tooltip--position-${this.position}`]: true,\n                [this.classes]: true\n              },\n              style: this.computedStyles\n            },\n            this.$slots.default\n          )\n      })\n\n      this.tooltip = new Tooltip().$mount(el)\n    },\n\n    destroy() {\n      if (!this.tooltip) {\n        return\n      }\n\n      this.tooltip.$el.classList.remove('active')\n\n      if (this.value) {\n        this.$emit('input', false)\n      }\n      setTimeout(() => {\n        this.tooltip?.$el.remove()\n        this.tooltip = null\n      }, 200)\n    },\n\n    setPosition() {\n      const targetCoords = this.target.getBoundingClientRect()\n      const targetCenterY = targetCoords.x + targetCoords.width / 2\n      const tooltipCoords = this.tooltip.$el.getBoundingClientRect()\n\n      switch (this.position) {\n        case POSITION.bottom: {\n          this.tooltip.$el.style.top =\n            targetCoords.y + targetCoords.height + this.offset + 'px'\n\n          this.tooltip.$el.style.left =\n            targetCenterY - tooltipCoords.width / 2 + 'px'\n          break\n        }\n\n        case POSITION.top: {\n          this.tooltip.$el.style.top =\n            targetCoords.y - tooltipCoords.height - this.offset + 'px'\n\n          this.tooltip.$el.style.left =\n            targetCenterY - tooltipCoords.width / 2 + 'px'\n          break\n        }\n      }\n    }\n  },\n\n  mounted() {\n    this.target = this.$el.parentElement\n\n    if (this.value === undefined) {\n      this.target.addEventListener('mouseover', this.show)\n      this.target.addEventListener('mouseleave', this.destroy)\n    }\n    document.addEventListener('scroll', this.destroy)\n\n    if (this.value === true) {\n      this.show()\n    }\n  },\n\n  beforeDestroy() {\n    this.target.removeEventListener('mouseover', this.show)\n    this.target.removeEventListener('mouseleave', this.destroy)\n    document.removeEventListener('scroll', this.destroy)\n  },\n\n  render(h) {\n    return h('')\n  }\n}\n</script>\n\n<style lang=\"stylus\">\n[__tooltip__].tooltip\n  display block\n  border-radius 4px\n  box-shadow 0 2px 24px 0 rgba(0, 0, 0, 0.16)\n  padding 6px 8px\n  position fixed\n  z-index 1000000\n  background-color #505050\n  transition opacity .2s, transform .2s\n  opacity 0\n  pointer-events none\n  border-color #505050\n  font-size 14px\n  line-height 18px\n  color white\n\n  &--anchor\n    &::before\n      content ''\n      display block\n      border-style solid\n      border-width 6px\n      position absolute\n      left 50%\n      border-color transparent\n      transform translateX(-50%)\n\n  &--position-bottom\n    transform translateY(-10px)\n    &::before\n      border-top none\n      top -6px\n      border-bottom-color inherit\n\n  &--position-top\n    transform translateY(10px)\n    &::before\n      border-color transparent\n      border-bottom none\n      bottom: -6px\n      border-top-color inherit\n\n  &.active\n    opacity 1\n    transform translateY(0)\n</style>\n", "[__tooltip__].tooltip {\n  display: block;\n  border-radius: 4px;\n  box-shadow: 0 2px 24px 0 rgba(0,0,0,0.16);\n  padding: 6px 8px;\n  position: fixed;\n  z-index: 1000000;\n  background-color: #505050;\n  transition: opacity 0.2s, transform 0.2s;\n  opacity: 0;\n  pointer-events: none;\n  border-color: #505050;\n  font-size: 14px;\n  line-height: 18px;\n  color: #fff;\n}\n[__tooltip__].tooltip--anchor::before {\n  content: '';\n  display: block;\n  border-style: solid;\n  border-width: 6px;\n  position: absolute;\n  left: 50%;\n  border-color: transparent;\n  transform: translateX(-50%);\n}\n[__tooltip__].tooltip--position-bottom {\n  transform: translateY(-10px);\n}\n[__tooltip__].tooltip--position-bottom::before {\n  border-top: none;\n  top: -6px;\n  border-bottom-color: inherit;\n}\n[__tooltip__].tooltip--position-top {\n  transform: translateY(10px);\n}\n[__tooltip__].tooltip--position-top::before {\n  border-color: transparent;\n  border-bottom: none;\n  bottom: -6px;\n  border-top-color: inherit;\n}\n[__tooltip__].tooltip.active {\n  opacity: 1;\n  transform: translateY(0);\n}\n"]
    },
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = undefined;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__ = /*#__PURE__*/normalizeComponent({}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);

function install(Vue) {
  if (install.installed) return;
  install.installed = true;
  Vue.component('Tooltip', __vue_component__);
}

var plugin = {
  install: install
};
var GlobalVue = null;

if (typeof window !== 'undefined') {
  GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
  GlobalVue = global.Vue;
}

if (GlobalVue) {
  GlobalVue.use(plugin);
}

export default __vue_component__;
export { install };
